import React, { useEffect, useRef, useState } from "react";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { IconButton } from "@mui/material";
const ImageWithBorders = ({ imageUrl, coordinates }) => {
  const canvasRef = useRef(null);
  const [rotationAngle, setRotationAngle] = useState(0);

  const handleRotate = () => {
    setRotationAngle((prevAngle) => prevAngle + 90);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const image = new Image();
    image.src = imageUrl;
    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.save();
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((rotationAngle * Math.PI) / 180);
      ctx.drawImage(image, -image.width / 2, -image.height / 2);
      ctx.strokeStyle = "#ff00002e";
      ctx.lineWidth = 2;
      const preFillColor = "#ff00002e";
      const fillColor = "#ff00002e";

      coordinates.forEach((coords) => {
        const [x1, y1, x2, y2] = coords;
        const width = x2 - x1;
        const height = y2 - y1;

        ctx.beginPath();
        ctx.rect(x1, y1, width, height);
        ctx.fillStyle = preFillColor;
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = fillColor;
        ctx.fillRect(x1, y1, width, height);
      });

      ctx.restore();

      setTimeout(() => {
        const scrollY = Math.max(coordinates[0][1] - 100, 0); // Subtract 100px from the y-coordinate

        // document.getElementById("pdfDialogContent").scrollTo({
        //   top: scrollY,
        //   behavior: "smooth",
        // });

        const element = document.getElementById("pdfDialogContent");
        if (element) {
          element.scrollTo({
            top: scrollY,
            behavior: "smooth",
          });
        } else {
          console.error("Element with ID 'pdfDialogContent' not found.");
        }

        // document.getElementById("pdfDialogContent").scrollTo({
        //   top: scrollY,
        //   behavior: "smooth",
        // });
      }, 1000);
    };
  }, [imageUrl, coordinates, rotationAngle]);

  return (
    <div>
      <canvas ref={canvasRef} />
      <IconButton
        style={{ position: "absolute", right: "8px", top: "40px" }}
        onClick={handleRotate}
      >
        <RotateRightIcon />
      </IconButton>
      {/* <button >Rotate</button> */}
    </div>
  );
};

export default ImageWithBorders;
